<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/bruno-giacosa')">Bruno Giacosa
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/cantina-roberto-voerzio')">Cantina Roberto
                        Voerzio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/piedmont/conterno-fantino')">Conterno Fantino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/g-d-vajra')">G. D. Vajra
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/gaja')">Gaja
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giacomo-conterno')">Giacomo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio')">Giuseppe
                        Mascarello e Figlio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/massolino')">Massolino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/poderi-aldo-conterno')">Poderi Aldo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/roagna')">Roagna
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/tenuta-la-giustiniana')">Tenuta La
                        Giustiniana
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/vigne-marina-coppi')">Vigne Marina Coppi
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Conterno Fantino</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Proveniente da una regione famosa a livello internazionale per l'enogastronomia, Conterno Fantino lo è
                        una delle cose migliori che siano mai uscite dal Piemonte. Fondata nel 1982 dai figli di due
                        Dinastie del vino piemontese, Conterno Fantino è una storia di grande amicizia, vinificazione moderna e
                        sfondo del patrimonio.
                    </div>

                    <div class="howto-title2">Due amici, una visione</div>
                    <div class="howto-text">
                        Claudio Conterno e Guido Fantino hanno iniziato a farsi un nome e la loro azienda nel
                        metà degli anni '80. Hanno preso la decisione senza precedenti di invecchiare il loro Barolo in botti di rovere francese e andare
                        attraverso un processo di macerazione e fermentazione più breve per le uve. Lo hanno scoperto facendo
                        questo il loro vino aveva molto più corpo e sapore di prima. In una mossa, hanno messo i loro nomi
                        la mappa. Oggi hanno 27 ettari di vigneto, dove coltivano quattro vitigni: il loro
                        famosa Barbera ovviamente ma anche Nebbiolo, Dolcetto e Chardonnay.
                    </div>

                    <div class="howto-title2">Un assaggio di Piemonte</div>
                    <div class="howto-text">
                        Il duo ha iniziato producendo un solo vino: un Barolo che si chiamava Ginestra, chiamato
                        dopo i pendii esposti a sud dove viene coltivato. Hanno letteralmente ampliato le loro proprietà
                        1989 quando si aggiunsero gli appezzamenti di Brico Bastia, lo stesso appezzamento dove oggi sorge la nuova cantina.
                        A poco a poco, hanno aumentato i loro terroir, mantenendo la loro visione di produrre semplici,
                        vino eccezionale. E ci sono riusciti, in gran parte grazie alla loro devozione all'eccellenza. Conterno
                        Fantino prende molto sul serio la loro qualità: l'agricoltura è biologica dal 1996 e tutte le uve
                        vengono raccolti a mano. I vigneti sono gestiti dallo stesso Claudio e sotto la sua attenta guida,
                        ci ha mostrato che il vino di buona qualità inizia davvero in casa. Tutti i loro vini sono multistrato
                        e multidimensionale e catturano la personalità piemontese unica di questo produttore.
                    </div>

                    <div class="howto-title2">La prossima generazione</div>
                    <div class="howto-text">
                        La vinificazione è nel DNA di Conterno Fantino. In questi giorni, la tenuta è gestita da un clan di Conternos
                        e Fantinos e assicura la prossima generazione di vinificatori. La loro passione per il vino è contagiosa
                        e solo il rigore intellettuale che le famiglie portano sia in vigna che in cantina
                        aumentato la già alta qualità dei vini.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Claudio è molto stimato tra gli addetti ai lavori, è presidente di Cuneo
                                filiale della CIA (Confederazione Italiana Agricoltori) e considerato come uno dei
                                produttori più modernisti di Barolo.
                            </li>
                            <li>Il Barolo Castelletto Vigna Pressenda 2017 di Conterno Fantino ha ottenuto un ammirevole 94 punti
                                sul punteggio complessivo. Con una capacità di invecchiamento di circa 15 anni, questo è un vino che
                                invecchierà magnificamente.
                            </li>
                            <li>Un tempo considerato "Les enfants terribles" della zona, l'approccio innovativo alla vinificazione di Conterno Fantino ha ridefinito la regione vinicola piemontese.
                            </li>
                            <li>Il Sori Ginestra 2016 ha ottenuto un fenomenale 98 punti da Wine Advocate di Robert Parker. I critici hanno definito questo vino “potente e deciso” ma allo stesso tempo “morbido e ricco”. La finestra extra lunga per bere non si aprirà almeno fino al 2026, quindi investitori
                                dovrà essere paziente.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Conterno Fantino</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Conterno Fantino stammt aus einer Region, die international für ihr Essen und ihren Wein bekannt ist
                        Eines der besten Dinge, die jemals aus dem Piemont gekommen sind. 1982 von zwei Söhnen gegründet
                        Conterno Fantino ist eine Geschichte großer Freundschaft, moderner Weinherstellung und der piemontesischen Weindynastien
                        Erbe-Hintergrund.
                    </div>

                    <div class="howto-title2">Zwei Freunde, eine Vision</div>
                    <div class="howto-text">
                        Claudio Conterno und Guido Fantino machten sich und ihr Weingut in der Region einen Namen
                        Mitte der 1980er Jahre. Sie trafen die beispiellose Entscheidung, ihren Barolo in französischen Eichenfässern zu reifen und loszulegen
                        durch einen kürzeren Mazerations- und Fermentationsprozess der Trauben. Das haben sie dadurch herausgefunden
                        Dadurch hatte ihr Wein viel mehr Körper und Geschmack als zuvor. Mit einem Zug trugen sie ihre Namen ein
                        die Karte. Heute verfügen sie über 27 Hektar Weinberge, auf denen sie vier Rebsorten anbauen: ihre
                        natürlich der berühmte Barbera, aber auch Nebbiolo, Dolcetto und Chardonnay.
                    </div>

                    <div class="howto-title2">Ein Vorgeschmack auf das Piemont</div>
                    <div class="howto-text">
                        Das Duo begann mit der Herstellung nur eines Weins – eines Barolo namens Ginestra
                        nach den Südhängen, wo es angebaut wird. Sie haben ihre Bestände im wahrsten Sinne des Wortes vergrößert
                        1989 kamen Parzellen von Brico Bastia hinzu, die gleiche Parzelle, auf der sich heute das neue Weingut befindet.
                        Nach und nach vergrößerten sie ihre Terroirs und behielten dabei ihre Vision bei, einfache,
                        hervorragender Wein. Und es gelang ihnen – vor allem aufgrund ihres Strebens nach Exzellenz. Conterno
                        Fantino nimmt ihre Qualität sehr ernst – der Anbau erfolgt seit 1996 biologisch und ausschließlich aus Trauben
                        werden von Hand gepflückt. Die Weinberge werden von Claudio selbst bewirtschaftet und unter seiner sorgfältigen Anleitung
                        Er hat uns gezeigt, dass guter Qualitätswein wirklich zu Hause beginnt. Alle ihre Weine sind vielschichtig
                        und mehrdimensional und fangen die einzigartige piemontesische Persönlichkeit dieses Produzenten ein.
                    </div>

                    <div class="howto-title2">Die nächste Generation</div>
                    <div class="howto-text">
                        Die Weinherstellung liegt in der DNA von Conterno Fantino. Heutzutage wird das Anwesen von einem Clan der Conternos geführt
                        und Fantinos und sichert die nächste Winzergeneration. Ihre Leidenschaft für Wein ist ansteckend
                        und die intellektuelle Strenge, die die Familien sowohl in den Weinbergen als auch im Keller an den Tag legen, ist einzigartig
                        steigerte die ohnehin schon hohe Qualität der Weine.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Claudio genießt unter Kennern großes Ansehen – er ist Präsident von Cuneo
                                Zweig der CIA (Confederazione Italiana Agricoltori) und gilt als einer der
                                modernsten Barolo-Produzenten.
                            </li>
                            <li>Conterno Fantinos Barolo Castelletto Vigna Pressenda 2017 erzielte bewundernswerte 94 Punkte
                                auf die Gesamtpunktzahl. Mit einer Lagerfähigkeit von etwa 15 Jahren ist dies ein Wein, der
                                wird wunderschön altern.
                            </li>
                            <li>Conterno Fantino galt einst als „Les enfants terribles“ der Region und hat mit seinem innovativen Ansatz bei der Weinherstellung die Weinregion Piemont neu definiert.
                            </li>
                            <li>Der Sori Ginestra 2016 erhielt phänomenale 98 Punkte von Robert Parker’s Wine Advocate. Kritiker nannten diesen Wein „kraftvoll und entschlossen“ und gleichzeitig „weich und reichhaltig“. Das extra lange Trinkfenster wird sich frühestens 2026 öffnen, so die Anleger
                                muss geduldig sein.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Conterno Fantino</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Originaire d'une région internationalement connue pour sa gastronomie et son vin, Conterno Fantino est
                        l'une des meilleures choses jamais sorties du Piémont. Fondée en 1982 par les fils de deux
                        Dynasties viticoles du Piémont, Conterno Fantino est une histoire de grande amitié, de vinification moderne et
                        arrière-plan patrimonial.
                    </div>

                    <div class="howto-title2">Deux amis, une vision</div>
                    <div class="howto-text">
                        Claudio Conterno et Guido Fantino ont commencé à se faire un nom et à faire connaître leur cave dans le
                        milieu des années 1980. Ils ont pris la décision sans précédent de faire vieillir leur Barolo en fûts de chêne français et de partir
                        grâce à un processus de macération et de fermentation plus court pour les raisins. Ils ont trouvé qu'en faisant
                        ce leur vin avait beaucoup plus de corps et de saveur qu'auparavant. D'un seul geste, ils mettent leur nom sur
                        la carte. Aujourd'hui, ils possèdent 27 hectares de vignes, où ils cultivent quatre cépages : leur
                        le célèbre Barbera bien sûr mais aussi le Nebbiolo, le Dolcetto et le Chardonnay.
                    </div>

                    <div class="howto-title2">Un avant-goût du Piémont</div>
                    <div class="howto-text">
                        Le duo a commencé par faire un seul vin - un Barolo qui s'appelait Ginestra, nommé
                        après les pentes exposées au sud où il est cultivé. Ils ont littéralement développé leurs avoirs en
                        1989 quand ils ont ajouté des parcelles de Brico Bastia, la même parcelle où se trouve aujourd'hui la nouvelle cave.
                        Petit à petit, ils ont agrandi leurs terroirs, tout en gardant leur vision de produire simple,
                        vin exceptionnel. Et ils ont réussi - en grande partie grâce à leur dévouement à l'excellence. Conterno
                        Fantino prend leur qualité très au sérieux - l'agriculture est biologique depuis 1996 et tous les raisins
                        sont cueillis à la main. Les vignobles sont gérés par Claudio lui-même et sous sa direction attentive,
                        il nous a montré qu'un vin de bonne qualité commence vraiment à la maison. Tous leurs vins sont multicouches
                        et multidimensionnelle et capturent la personnalité piémontaise unique de ce producteur.
                    </div>

                    <div class="howto-title2">La prochaine génération</div>
                    <div class="howto-text">
                        La vinification est dans l'ADN de Conterno Fantino. Aujourd'hui, le domaine est dirigé par un clan de Conternos
                        et Fantinos et assure la prochaine génération de viticulteurs. Leur passion pour le vin est contagieuse
                        et la rigueur intellectuelle que les familles apportent tant à la vigne qu'à la cave n'a
                        augmenté la qualité déjà élevée des vins.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Claudio est très apprécié des connaisseurs; il est président de Cuneo's
                                branche de la CIA (Confederazione Italiana Agricoltori) et considérée comme l'une des
                                producteurs les plus modernistes de Barolo.
                            </li>
                            <li>Le Barolo Castelletto Vigna Pressenda 2017 de Conterno Fantino a marqué un admirable 94 points
                                sur la notation globale. D'une garde d'environ 15 ans, c'est un vin qui
                                vieillira magnifiquement.
                            </li>
                            <li>Autrefois considéré comme "Les enfants terribles" de la région, l'approche innovante de Conterno Fantino en matière de vinification a redéfini la région viticole du Piémont.
                            </li>
                            <li>Le Sori Ginestra 2016 a obtenu la note phénoménale de 98 points du Wine Advocate de Robert Parker. Les critiques ont qualifié ce vin de "puissant et déterminé" tout en étant "doux et riche". La fenêtre de consommation extra longue ne s'ouvrira pas avant au moins 2026, donc les investisseurs
                                faudra être patient.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Conterno Fantino</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Hailing from a region that is internationally famous for its food and wine, Conterno Fantino is
                        one of the best things to have ever come out of Piedmont. Founded in 1982 by the sons of two
                        Piedmont wine dynasties, Conterno Fantino is a story of great friendship, modern winemaking and
                        heritage background.
                    </div>

                    <div class="howto-title2">Two friends, one vision</div>
                    <div class="howto-text">
                        Claudio Conterno and Guido Fantino began making a name for themselves and their winery in the
                        mid-1980s. They made the unprecedented decision to age their Barolo in French oak barrels and go
                        through a shorter maceration and fermentation process for the grapes. They found that by doing
                        this their wine had far more body and flavour than before. In one move, they put their names on
                        the map. Today they have 27 hectares of vineyard, where they grow four grape varietals: their
                        famous Barbera of course but also Nebbiolo, Dolcetto and Chardonnay.
                    </div>

                    <div class="howto-title2">A taste of Piedmont</div>
                    <div class="howto-text">
                        The duo started by making just one wine - a Barolo that went by the name of Ginestra, named
                        after the south-facing slopes where it is grown. They quite literally grew their holdings in
                        1989 when they added plots from Brico Bastia, the same plot where the new winery stands today.
                        Bit by bit, they increased their terroirs, all the keeping their vision of producing simple,
                        outstanding wine. And they succeeded - largely due to their devotion to excellence. Conterno
                        Fantino takes their quality very seriously - farming has been organic since 1996 and all grapes
                        are picked by hand. The vineyards are managed by Claudio himself and under his careful guidance,
                        he has shown us that good quality wine truly begins at home. All their wines are multi-layered
                        and multi-dimensional and capture the unique Piedmont personality of this producer.
                    </div>

                    <div class="howto-title2">The next generation</div>
                    <div class="howto-text">
                        Winemaking is in the Conterno Fantino DNA. These days, the estate is run by a clan of Conternos
                        and Fantinos and assures the next winemaking generation. Their passion for wine is infectious
                        and the intellectual rigour the families bring to both the vineyards and the cellar has only
                        increased the already high quality of the wines.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>Claudio is very highly regarded among those in the know - he is president of Cuneo’s
                                branch of the CIA (Confederazione Italiana Agricoltori) and considered as one of the
                                most modernist producers of Barolo.
                            </li>
                            <li>Conterno Fantino’s Barolo Castelletto Vigna Pressenda 2017 scored an admirable 94 points
                                on aggregate scoring. With a cellaring ability of around 15 years, this is a wine that
                                will age beautifully.
                            </li>
                            <li>Once considered “Les enfants terribles” of the area, Conterno Fantino’s innovative approach to winemaking has redefined the Piedmont wine region.
                            </li>
                            <li>The Sori Ginestra 2016 scored a phenomenal 98 points from Robert Parker’s Wine Advocate. Critics called this wine “powerful and determined” while at the same time being “soft and rich”. The extra long drinking window won’t open until at least 2026, so investors
                                will need to be patient.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CantinaRobertoVoerzio",
    head: {
        title: 'Conterno Fantino | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional quality of Conterno Fantino wines from the Piedmont region in Italy. Experience the perfect balance of tradition and innovation in every bottle.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
            items: [
                {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
                {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
                {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
                {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
                {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
                {report: 'Giacomo Conterno', src: '/wine-guide/italy/piedmont/giacomo-conterno'},
                {
                    report: 'Giuseppe Mascarello e Figlio',
                    src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
                },
                {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
                {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
                {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
                {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
                {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
